import React, { ReactElement, ReactNode } from 'react';
import {
  Col, FormGroup, Label, Row,
} from 'idsk-react-components';
import './formElementWrapper.scss';
import classNames from 'classnames';

interface Props {
  sectionClass?: string;
  required?: boolean;
  children: ReactNode;
  label: string,
  fieldName: string,
  getFieldErrorMessage: (fieldName: string) => string | undefined;
  labelClass?: string;
  width?: 'full' | 'one-quarter' | 'one-third' | 'one-half' | 'two-thirds' | 'three-quarters';
}

const FormElementWrapper = ({
  sectionClass, required, children, label, fieldName, getFieldErrorMessage, labelClass, width,
}: Props): ReactElement => {
  const classes = classNames(
    'input-label',
    labelClass,
  );
  return (
    <section className={sectionClass}>
      <FormGroup
        error={!!getFieldErrorMessage(fieldName)}
      >
        <Row>
          <Col width={width || 'full'}>
            <Label className={classes} htmlFor={fieldName}>{label}
              {required ? '' : <span className="not-required"> (nepovinný údaj)</span>}
            </Label>
            {children}
          </Col>
        </Row>
      </FormGroup>
    </section>
  );
};

export default FormElementWrapper;
